import {
  Box,
  CardMedia,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";

import mobile_imgSmUrl from "@/assets/images/downloadApp/mobile_sm.png";
import mobile_imgLgUrl from "@/assets/images/downloadApp/mobile_lg.png";
import { FONT_SECONDARY } from "@/theme/typography";
import { getBgImageStyles } from "../Resources/styles";
import useResponsive from "@/hooks/useResponsive";
import { getAppLinks } from "@/utils/getAppLinks";

interface IProps {
  type?: "primary" | "secondary";
}
const DownloadApp: React.FC<IProps> = ({ type = "primary" }) => {
  const isSmallMobile = useMediaQuery("(max-width: 374.98px)");
  const isMobile = useResponsive("down", "md");
  const appLinks = getAppLinks(!isMobile, "download");

  return (
    <Box borderRadius={5} sx={getBgImageStyles(isSmallMobile, type)}>
      <Grid
        container
        columnSpacing={{ xs: 0, md: 2.5 }}
        rowSpacing={{ xs: 8.5, md: 0 }}
      >
        <Grid item xs={12} md={6}>
          <Box
            pl={{ md: 5, lg: 8, xl: 11 }}
            py={{ md: 6, lg: 14 }}
            display="flex"
            flexDirection="column"
            height="100%"
            boxSizing="border-box"
            justifyContent="center"
          >
            <Typography
              variant="h2"
              component="p"
              color="white"
              mb={2}
              maxWidth={540}
            >
              Download app
            </Typography>

            <Typography
              variant={type === "primary" ? "subtitle2" : "subtitle1"}
              component="p"
              fontWeight={type === "primary" ? "" : 400}
              fontFamily={FONT_SECONDARY}
              fontSize={type === "primary" ? "" : "1.5rem !important"}
              color={{ xs: "#707580", md: "#EDEDED" }}
              mb={{ xs: 2.5, md: 9, lg: type === "primary" ? 16 : 9 }}
            >
              Download our free and user-friendly app to activate your trackers, monitor your vehicles and assets, and access the platform from anywhere.
            </Typography>

            <Box
              display="flex"
              gap={isSmallMobile ? 0.5 : 2}
              justifyContent={{ xs: "space-around", sm: "start" }}
            >
              {appLinks.map(({ AppIcon, href }, index) => (
                <IconButton
                  component="a"
                  target="_blank"
                  href={href}
                  key={index}
                  sx={{ padding: 0 }}
                >
                  <AppIcon />
                </IconButton>
              ))}
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            pt={{ xs: 0, md: 8, lg: 9 }}
            height="100%"
            boxSizing="border-box"
            display="flex"
            justifyContent="end"
            alignItems="end"
          >
            <CardMedia
              component="img"
              loading="lazy"
              image={isMobile ? mobile_imgSmUrl : mobile_imgLgUrl}
              alt="mobile with map"
              sx={{ maxWidth: { xs: "auto", md: 516 } }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DownloadApp;
